// Actions
export const INIT_GOOGLE_TRANSLATE = 'INIT_GOOGLE_TRANSLATE';
export const GOOGLE_TRANSLATE_READY = 'GOOGLE_TRANSLATE_READY'; // Used in both Redux and CustomEvent
export const GOOGLE_TRANSLATE_RESET = 'GOOGLE_TRANSLATE_RESET'; // Used in both Redux and CustomEvent
export const GOOGLE_TRANSLATE_CHANGE_LANGUAGE =
  'GOOGLE_TRANSLATE_CHANGE_LANGUAGE'; // Used in both Redux and CustomEvent

// HTML IDs
export const googleTranslateElementWrapperId = 'google_translate_element';

// Constants from the google translate widget code
export const translateCookieName = 'googtrans';

// Many assumptions made here about languages being similar
//   but the primary purpose here is to ensure some kind of translation occurs.
export const ploneTranslateMapping = {
  'af-na': 'af',
  'af-za': 'af',
  'ar-ar': 'ar',
  'ar-ma': 'ar',
  'ar-sa': 'ar',
  'ay-bo': 'ay',
  'az-az': 'az',
  'be-by': 'be',
  'bg-bg': 'bg',
  'bn-bd': 'bn',
  'bn-in': 'bn',
  'bs-ba': 'bs',
  'ca-es': 'ca',
  'cs-cz': 'cs',
  'cy-gb': 'cy',
  'da-dk': 'da',
  'de-at': 'de',
  'de-ch': 'de',
  'de-de': 'de',
  'el-gr': 'el',
  'en-au': 'en',
  'en-ca': 'en',
  'en-gb': 'en',
  'en-ie': 'en',
  'en-in': 'en',
  'en-pi': 'en',
  'en-ud': 'en',
  'en-us': 'en',
  'en-za': 'en',
  'eo-eo': 'eo',
  'es-419': 'es',
  'es-ar': 'es',
  'es-cl': 'es',
  'es-co': 'es',
  'es-ec': 'es',
  'es-es': 'es',
  'es-la': 'es',
  'es-mx': 'es',
  'es-ni': 'es',
  'es-us': 'es',
  'es-ve': 'es',
  'et-ee': 'et',
  'eu-es': 'eu',
  'fa-ir': 'fa',
  'fi-fi': 'fi',
  'fo-fo': 'fo',
  'fr-be': 'fr',
  'fr-ch': 'fr',
  'fr-fr': 'fr',
  'ga-ie': 'ga',
  'gl-es': 'gl',
  'gn-py': 'gn',
  'gu-in': 'gu',
  'he-il': 'iw',
  'hi-in': 'hi',
  'hr-hr': 'hr',
  'hu-hu': 'hu',
  'hy-am': 'hy',
  'id-id': 'id',
  'it-it': 'it',
  'ja-jp': 'ja',
  'jv-id': 'jw',
  'ka-ge': 'ka',
  'kk-kz': 'kk',
  'km-kh': 'km',
  'kn-in': 'kn',
  'ko-kr': 'ko',
  'ku-tr': 'ku',
  'la-va': 'la',
  'li-nl': 'li',
  'lt-lt': 'lt',
  'lv-lv': 'lv',
  'mg-mg': 'mg',
  'mk-mk': 'mk',
  'ml-in': 'ml',
  'mn-mn': 'mn',
  'mr-in': 'mr',
  'ms-my': 'ms',
  'ms-bn': 'ms',
  'mt-mt': 'mt',
  'nl-be': 'nl',
  'nl-nl': 'nl',
  'or-in': 'or',
  'pa-in': 'pa',
  'pl-pl': 'pl',
  'ps-af': 'ps',
  'pt-br': 'pt',
  'qu-pe': 'qu',
  'ro-ro': 'ro',
  'ru-ru': 'ru',
  'sa-in': 'sa',
  'se-no': 'se',
  'si-lk': 'si',
  'sk-sk': 'sk',
  'sl-si': 'sl',
  'so-so': 'so',
  'sq-al': 'sq',
  'sr-rs': 'sr',
  'sv-se': 'sv',
  'sw-ke': 'sw',
  'ta-in': 'ta',
  'tg-tj': 'tg',
  'th-th': 'th',
  'tl-ph': 'tl',
  'tr-tr': 'tr',
  'tt-ru': 'tt',
  'uk-ua': 'uk',
  'ur-pk': 'ur',
  'uz-uz': 'uz',
  'vi-vn': 'vi',
  'xh-za': 'xh',
  'yi-de': 'yi',
  'zh-hans': 'zh-CN',
  'zh-hant': 'zh-TW',
  'zh-hk': 'zh-TW',
  'zh-sg': 'zh-CN',
  'zu-za': 'zu',
  he: 'iw',
  lu: 'lua',
  tw: 'ak', // Not too sure on this one
};

export const languagesNotSupportedByPlone = [
  'ace',
  'alz',
  'av',
  'awa',
  'bal',
  'ban',
  'bbc',
  'bci',
  'bem',
  'ber-Latn',
  'ber',
  'bew',
  'bho',
  'bik',
  'bm-Nkoo',
  'bts',
  'btx',
  'bua',
  'ceb',
  'cgg',
  'chk',
  'chm',
  'ckb',
  'cnh',
  'crh-Latn',
  'crh',
  'crs',
  'din',
  'doi',
  'dov',
  'dyu',
  'fa-AF',
  'fon',
  'fur',
  'gaa',
  'gom',
  'haw',
  'hil',
  'hmn',
  'hrx',
  'iba',
  'ilo',
  'is-IS',
  'iu-Latn',
  'jam',
  'kac',
  'kek',
  'kha',
  'kri',
  'ktu',
  'lij',
  'lmo',
  'ltg',
  'luo',
  'lus',
  'mad',
  'mak',
  'mam',
  'mfe',
  'min',
  'mni-Mtei',
  'ms-Arab',
  'mwr',
  'ndc-ZW',
  'ne-NP',
  'new',
  'nhe',
  'nso',
  'nus',
  'pa-Arab',
  'pag',
  'pam',
  'pap',
  'rom',
  'sat-Latn',
  'sat',
  'scn',
  'shn',
  'sus',
  'szl',
  'tet',
  'trp',
  'yue',
  'tiv',
  'tpi',
  'tcy',
  'tum',
  'tyv',
  'udm',
  'vec',
  'war',
  'sah',
  'yua',
  'zap',
];
